/** Format ISO datetime for itinerary display. */
export function formatItineraryTime(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function formatLayoverDuration(minutes) {
  if (minutes == null) return '';
  if (minutes < 60) return `${minutes}m`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

/** Build default notes text for quote request when user has connection concerns. */
export function buildConnectionNotesForQuote(offer) {
  const lines = [];
  if (offer?.baggage?.summary) lines.push(`Baggage: ${offer.baggage.summary}`);
  (offer?.connectionNotes || []).forEach((n) => lines.push(n));
  (offer?.slices || []).forEach((slice) => {
    (slice.layovers || []).forEach((l) => {
      if (l.baggageNote) lines.push(`${l.airport}: ${l.baggageNote}`);
    });
  });
  return lines.join('\n');
}

export function hasMultiLegJourney(offer) {
  return (offer?.stops ?? 0) > 0 || (offer?.slices?.[0]?.segments?.length ?? 0) > 1;
}
